import type { ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from '@/shared/i18n';
import { QueryProvider } from './query';

interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <I18nextProvider i18n={i18n}>
      <QueryProvider>{children}</QueryProvider>
    </I18nextProvider>
  );
}
